<template>
  <div class="login">
    <h1>Profil anpassen</h1>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <b-alert v-model="isSucceded" variant="success">
      {{ $t('profile.success') }}
    </b-alert>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)">

        <validation-provider vid="anrede" name="anrede">
          <b-form-group id="input-group-anrede" label="Anrede" label-for="input-anrede">
            <b-form-select v-model="form.userProfile.anrede" :options="titles" id="input-anrede"></b-form-select>
          </b-form-group>
        </validation-provider>

        <b-form-group id="input-group-firma" label="Firma" label-for="input-firma">
          <b-form-input
            id="input-firma"
            v-model="form.userProfile.firma"
            type="text"
            placeholder="Firma angeben"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-zusatz" label="Zusatz" label-for="input-zusatz">
          <b-form-input
            id="input-company-addition"
            v-model="form.userProfile.zusatz"
            type="text"
            placeholder="Zusatz angeben"
          ></b-form-input>
        </b-form-group>

        <validation-provider vid="vorname" rules="required" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-vorname" label="Vorname *" label-for="input-vorname">
            <b-form-input
              id="input-vorname"
              v-model="form.userProfile.vorname"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Vorname angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider vid="name" rules="required" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-name" label="Nachname *" label-for="input-name">
            <b-form-input
              id="input-name"
              v-model="form.userProfile.name"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Nachname angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-row>
          <b-col cols="9">
            <validation-provider vid="strasse" rules="required" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-strasse" label="Strasse *" label-for="input-strasse">
                <b-form-input
                  id="input-strasse"
                  v-model="form.userProfile.strasse"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="Strasse angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col class="col">
            <b-form-group id="input-group-haus-nr" label="Nr." label-for="input-haus-nr">
              <b-form-input
                id="input-haus-nr"
                v-model="form.userProfile.hausNr"
                type="text"
                placeholder="Nr. angeben"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <validation-provider vid="plz" rules="required|numeric" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-plz" label="PLZ *" label-for="input-plz">
                <b-form-input
                  id="input-plz"
                  v-model="form.userProfile.plz"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="PLZ angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col class="col">
            <validation-provider vid="ort" rules="required" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-city" label="Ort *" label-for="input-ort">
                <b-form-input
                  id="input-ort"
                  v-model="form.userProfile.ort"
                  :state="onValidateField(valid, errors, changed)"
                  type="text"
                  placeholder="Stadt angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <validation-provider vid="land">
          <b-form-group id="input-group-land" label="Land" label-for="input-land">
            <b-form-select v-model="form.userProfile.land" :options="countries" id="input-land"></b-form-select>
          </b-form-group>
        </validation-provider>

        <validation-provider vid="telefon" rules="required" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-telefon" label="Telefon *" label-for="input-telefon">
            <b-form-input
              id="input-telefon"
              v-model="form.userProfile.telefon"
              :state="onValidateField(valid, errors, changed)"
              type="text"
              placeholder="Telefonnr. angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider vid="IdentificationMobileNr" rules="phoneNumber" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-identification-number" label="Telefonnr. für Bestätigungscode *" label-for="input-identification-number">
            <b-form-input
              id="input-identification-number"
              v-model="form.identificationMobileNr"
              :state="onValidateField(valid, errors, changed)"
              placeholder="Format: +41 79 999 99 99"
            ></b-form-input>
            <small>Sie erhalten beim Einloggen einen Bestätigungscode auf diese Telefonnr.</small>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-form-group>
          <b-form-checkbox
            id="tech-contact"
            v-model="form.userProfile.technischerKontakt"
            name="ctech-contact"
          >
            Technischer Kontakt
          </b-form-checkbox>
          <small>Wenn Sie Unternehmer sind und Gesuche für Ihre Kunden erfassen, werden Sie als Kontaktperson für technische Rückfragen vorgemerkt.</small>
        </b-form-group>

        <b-button type="submit" variant="primary" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Profil speichern
        </b-button>
        <b-button type="submit" variant="primary" v-else>Profil speichern</b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      countries: [
        { value: 16, text: 'Schweiz' },
        { value: 17, text: 'Deutschland' },
        { value: 18, text: 'Österreich' },
        { value: 19, text: 'Lichtenstein' },
        { value: 21, text: 'Frankreich' },
        { value: 20, text: 'Italien' },
        { value: 92, text: 'Israel' },
        { value: 91, text: 'USA' },
        { value: 241, text: 'Grossbritanien' }
      ],
      titles: [
        { value: 'Herr', text: 'Herr' },
        { value: 'Frau', text: 'Frau' },
        { value: 'Herr & Frau', text: 'Herr & Frau' }
      ]
    }),
    created () {
      this.getProfile()
    },
    methods: {
      scrollTo () {
        this.$scrollTo('.logo')
      },
      getProfile () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('profile/GET_PRFOFILE', this.form).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('profile/UPDATE_PROFILE', this.form).then(res => {
          const { data, errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          const { userProfile } = data.userProfileUpdate
          const { vorname, name, technischerKontakt } = userProfile
          const fullname = `${vorname} ${name}`
          this.$store.commit('user/SET_CURRENT_USER', { fullname, technischerKontakt })

          this.isSucceded = true
          this.isSubmitting = false
          this.scrollTo()
          this.reset()
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.scrollTo()
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    computed: {
      ...mapGetters({ form: 'profile/PROFILE' })
    }
  }
</script>

<style lang="scss" scoped>
  .agb-links{
    @include list-unstyled;
    margin-top: 5rem;

    li{
      &:not(:first-child) {
        padding-left: 30px;
      }
      display: inline-block;
    }
  }
</style>
